import { ShiftDetailResponseItem } from '@/types/service-response'

export class ShiftEmployeeDetails {
  public constructor (
    readonly detailId: number | null,
    readonly row: number | null,
    readonly dateStart: string,
    readonly dateEnd: string,
    readonly employeeId: number | null,
    readonly note: string,
    readonly taskId: number | null,
    readonly projectId: number | null,
    readonly competenceName?: string,
    readonly educationName?: string,
    readonly planningGroup?: number | null,
  ) {}

  public static createListFromResponse (data: ShiftDetailResponseItem[]): Array<ShiftEmployeeDetails> {

    return data.map((item: ShiftDetailResponseItem) => {
      return new ShiftEmployeeDetails(
        item.detailID,
        item.Zeile,
        item.datumStart ? item.datumStart : '',
        item.datumEnde ? item.datumEnde : '',
        item.MitarbeiterID,
        item.NotizElement,
        item.ArbeitID,
        item.ProjektID ? item.ProjektID : null,
        item.KompetenzName,
        item.BildungsgradName,
        item.Planungsgruppe
      )
    })
  }
}
